var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 14.6667V17.3333C9.66683 18.8061 8.47292 20 7.00016 20C5.5274 20 4.3335 18.8061 4.3335 17.3333C4.3335 15.8606 5.5274 14.6667 7.00016 14.6667H9.66683ZM9.66683 14.6667H15.0002M9.66683 14.6667V9.33333M15.0002 14.6667V17.3333C15.0002 18.8061 16.1941 20 17.6668 20C19.1396 20 20.3335 18.8061 20.3335 17.3333C20.3335 15.8606 19.1396 14.6667 17.6668 14.6667H15.0002ZM15.0002 14.6667V9.33333M15.0002 9.33333H9.66683M15.0002 9.33333V6.66667C15.0002 5.19391 16.1941 4 17.6668 4C19.1396 4 20.3335 5.19391 20.3335 6.66667C20.3335 8.13943 19.1396 9.33333 17.6668 9.33333H15.0002ZM9.66683 9.33333V6.66667C9.66683 5.19391 8.47292 4 7.00016 4C5.5274 4 4.3335 5.19391 4.3335 6.66667C4.3335 8.13943 5.5274 9.33333 7.00016 9.33333H9.66683Z",
    stroke: "#3A3428",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommand);
export default __webpack_public_path__ + "static/media/Command.ce9be9eef1f8699cfdfafb7e82872acf.svg";
export { ForwardRef as ReactComponent };